/**
 * item的���据类型
 */
export const DataType = {
  /** 输入框 */
  INPUT: "input",
  /** 下拉选择 */
  SELECT: "select",
  /** 日期 */
  DATE: "date",
  /** 日期时间 */
  DATETIME: "datetime",
  /** 切换tabs */
  TAB: "tab",
  /** 余额 */
  MONEY: "money",
  /** 金额/元 **/
  MONEY_YUAN: "moneyYuan",
  /** 用户显示id */
  USER_UID: "uid",
  /** 用户真实id */
  USER_ID: "userId",
  /** 图片 */
  IMAGE: "image",
  /** 图片 */
  IMAGE_BASE64: "imageBase64",
  /** 头像 */
  AVATAR: "avatar",
};

/**
 * item类型
 */
export const ItemType = {
  /** 输入框 */
  INPUT: "input",
  /** 下拉选择 */
  SELECT: "select",
  /** 日期 */
  DATE: "date",
  /** 日期时间 */
  DATETIME: "datetime",
  /** 切换tabs */
  TAB: "tab",
  /** 余额 */
  MONEY: "money",
};



// WEBPACK FOOTER //
// ./src/components/ExTable/ExTableEnum.js